import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { client } from './graphql/apolloClient';
import {
  AnalyticsTracker,
  CognitoProvider,
  configureAmplify,
  handleSocialSignIn,
} from '@sandtech-hub-monorepo/ui-auth-kit';
import { BrandKit, ThemeProvider } from '@sandtech-hub-monorepo/ui-kit';

import App from './app/app';
import { AppRoutesPaths } from './routes/types';

configureAmplify(
  process.env['NX_USER_POOL_ID'] || '',
  process.env['NX_USER_POOL_CLIENT_ID'] || '',
  process.env['NX_IDP_DOMAIN'] || '',
  [`${window.location.origin}${AppRoutesPaths.OauthToken}`],
  [`${window.location.origin}${AppRoutesPaths.Login}`],
  process.env['NX_COOKIE_DOMAIN'] || ''
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <ThemeProvider brandKit={BrandKit.FIT}>
      <CognitoProvider onSocialSignIn={handleSocialSignIn}>
        <ApolloProvider client={client}>
          <AnalyticsTracker />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ApolloProvider>
      </CognitoProvider>
    </ThemeProvider>
  </StrictMode>
);
